module.exports = __webpack_public_path__ + "static/img/albrich.a3f67c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/nilfgaardian/albrich.png
// module id = kgMO
// module chunks = 0